// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"uj-q9z2x","container":"_1oLsy6vx","grey-bar":"_1IMg4-T2","orange-bar":"_2wbBtYYx","percentage":"_2wxwqsDW","bars-container":"_2kTrLmiD","info-display-container":"_2Ytbx5K_"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/HorizontalBarChart/HorizontalBarChart.styl
// module id = 506
// module chunks = 0